import { SET_USER, UNSET_USER, User, UserAction } from "../types/user";

export function setUser(user: User): UserAction {
  return {
    type: SET_USER,
    user,
  };
}

export function unsetUser(): UserAction {
  return {
    type: UNSET_USER,
  };
}
